const userRoles = {
  "admin": "Admin",
  "callcentre": "Call Centre",
  "coach": "Coach",
  "coach_restricted": "Coach Restricted",
  "qc": "QC",
  "setup_portal": "Setup Portal",
  "super_admin": "Super Admin",
  "tcs_coach": "TCS coach",
  "verify_sales": "Verify Sales",
  "voice_enabled": "Voice Enabled"
}


export { userRoles }
